// src/com/veh_info/VehInfoView.js
import InfoIcon from '@mui/icons-material/Info';
import DoneIcon from '@mui/icons-material/Done';
import DraggableViewer from '../common/DraggableViewer';
import { AppPalette, AppWord } from '../../model/AppConst';
import { Button, DialogActions, Grid } from '@mui/material';
import { LabelAndValue } from '../common/CvoStyled';

export default function VehInfoView({
    open,
    item,
    onClose,
    onRequestEdit
}) {

    if(!open || !item) return null;
    
    return(
        <DraggableViewer
            open={open}
            onClose={onClose}
            title={`차량정보 - ${item.vehPlates}`}
            startIcon={<InfoIcon fontSize={AppWord.LARGE} />}
        >
            <Grid container spacing={1} padding={2} style={{minWidth: 700}}>
                <Grid item xs={3}>
                    <LabelAndValue
                        label="차량번호"
                        value={item.vehPlates}
                    />
                </Grid>
                <Grid item xs={3}>
                    <LabelAndValue
                        label="지도표시명"
                        value={item.vehAlias}
                    />
                </Grid>
                <Grid item xs={3}>
                    <LabelAndValue
                        label="운전자"
                        value={item.driverName}
                    />
                </Grid>
                <Grid item xs={3}>
                    <LabelAndValue
                        label="운전자휴대전화"
                        value={item.driverMobile}
                    />
                </Grid>

                <Grid item xs={3}>
                    <LabelAndValue
                        label="차종,톤수"
                        value={item.vehTypeTon}
                    />
                </Grid>
                <Grid item xs={3}>
                    <LabelAndValue
                        label="단말기"
                        value={item.termId || '없음'}
                    />
                </Grid>
                <Grid item xs={3}>
                    <LabelAndValue
                        label="전원타입"
                        value={item.termPowerValue}
                    />
                </Grid>
                <Grid item xs={3}>
                </Grid>

                <Grid item xs={12}>
                    <LabelAndValue
                        label="차고지주소"
                        value={item.vehAddr || '없음'}
                    />
                </Grid>
                <Grid item xs={12}>
                    <LabelAndValue
                        label="최종위치보고"
                        value={item.gpsTime}
                    />
                </Grid>
            </Grid>
            <DialogActions>
                {
                    onRequestEdit &&
                    <Button onClick={() => onRequestEdit(item)}
                        variant={AppPalette.VariantContained}
                        color={AppPalette.InheritColor}
                        sx={{width: 120}}
                    >
                        차량정보 수정
                    </Button>
                }
                <Button onClick={onClose}
                    variant={AppPalette.VariantContained}
                    color={AppPalette.PrimaryColor}
                    sx={{width: 120}}
                    startIcon={<DoneIcon />}
                >
                    닫기
                </Button>
            </DialogActions>
        </DraggableViewer>
    );
}